import { InjectionToken } from '@angular/core';
import { ArtifactRendererMap } from '../types';

export const ARTIFACT_RENDERERS: InjectionToken<ArtifactRendererMap> = new InjectionToken('ARTIFACT_RENDERERS');
